"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserTasks = void 0;
const dayjs = require("dayjs");
const dayjsCustomParseFormatPlugin = require("dayjs/plugin/customParseFormat");
dayjs.extend(dayjsCustomParseFormatPlugin);
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseUserTasks(processData) {
    const userTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.UserTask);
    const noUserTasksFound = !((userTasksRaw === null || userTasksRaw === void 0 ? void 0 : userTasksRaw.length) > 0);
    if (noUserTasksFound) {
        return [];
    }
    const userTasks = userTasksRaw.map((userTaskRaw) => {
        const flowNodeId = userTaskRaw.id;
        try {
            return parseUserTask(userTaskRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return userTasks;
}
exports.parseUserTasks = parseUserTasks;
function parseUserTask(userTaskRaw) {
    const userTask = (0, ActivityFactory_1.createActivityInstance)(userTaskRaw, index_1.Model.Activities.UserTask);
    userTask.assignee = userTaskRaw[index_1.BpmnTags.CamundaProperty.Assignee];
    userTask.candidateUsers = userTaskRaw[index_1.BpmnTags.CamundaProperty.CandidateUsers];
    userTask.candidateGroups = userTaskRaw[index_1.BpmnTags.CamundaProperty.CandidateGroups];
    userTask.formFields = parseFormFields(userTaskRaw);
    userTask.dueDate = parseDate(userTaskRaw[index_1.BpmnTags.CamundaProperty.DueDate]);
    userTask.followUpDate = parseDate(userTaskRaw[index_1.BpmnTags.CamundaProperty.FollowupDate]);
    setCustomFormForUserTask(userTask);
    setDescriptionForUserTask(userTask);
    setFinishedMessageForUserTask(userTask);
    setAssignedUserIdsForUserTask(userTask);
    return userTask;
}
function parseFormFields(userTaskRaw) {
    const extensionElements = userTaskRaw[index_1.BpmnTags.FlowElementProperty.ExtensionElements];
    if (!extensionElements) {
        return [];
    }
    const formDataRaw = extensionElements[index_1.BpmnTags.CamundaProperty.FormData];
    if (!formDataRaw) {
        return [];
    }
    const formFieldsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(formDataRaw, index_1.BpmnTags.CamundaProperty.FormField);
    if (!formFieldsRaw) {
        return [];
    }
    return formFieldsRaw.map(parseFormField);
}
function parseFormField(formFieldRaw) {
    const formField = new index_1.Model.Activities.Types.UserTaskFormField();
    formField.id = formFieldRaw.id;
    formField.label = formFieldRaw.label;
    formField.type = formFieldRaw.type;
    formField.defaultValue = formFieldRaw.defaultValue;
    formField.customForm = formFieldRaw.customForm;
    if (formField.type === 'enum') {
        const rawValues = (0, TypeFactory_1.getModelPropertyAsArray)(formFieldRaw, index_1.BpmnTags.CamundaProperty.Value);
        const valueMapper = (enumValueRaw) => {
            const enumValue = new index_1.Model.Activities.Types.FormFieldEnumValue();
            enumValue.id = enumValueRaw.id;
            enumValue.name = enumValueRaw.name;
            return enumValue;
        };
        formField.enumValues = rawValues ? rawValues.map(valueMapper) : [];
    }
    return formField;
}
function parseDate(value) {
    const notAValidDate = !((value === null || value === void 0 ? void 0 : value.length) > 0) || !dayjs(value, 'YYYY-MM-DDTHH:mm:ss', true).isValid();
    if (notAValidDate) {
        return undefined;
    }
    return dayjs(value).toDate();
}
function setCustomFormForUserTask(userTask) {
    var _a;
    userTask.customForm =
        (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('customForm', userTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function setDescriptionForUserTask(userTask) {
    var _a;
    userTask.description = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('description', userTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function setFinishedMessageForUserTask(userTask) {
    var _a;
    userTask.finishedMessage = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('finishedMessage', userTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
function setAssignedUserIdsForUserTask(userTask) {
    var _a;
    userTask.assignedUsersConfig = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.assignUserIds', userTask.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
}
//# sourceMappingURL=UserTaskParser.js.map